if (!customElements.get("el-lash-timeline")) {
  class ElLashTimeline extends HTMLElement {
    constructor() {
      super();
      this.enterTimer = null;
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      if (this.dataset.ready === "true") return;

      this.dataset.ready = "true";
      this.addEventListener("click", this.handleClick);
    }

    handleClick(event) {
      const tab = event.target.closest("[data-timeline-tab]");

      if (!tab || !this.contains(tab)) return;
      if (tab.classList.contains("is-active")) return;

      const index = tab.dataset.index;
      const currentTab = this.querySelector("[data-timeline-tab].is-active");
      const nextPanel = this.querySelector(
        `[data-timeline-panel][data-index="${index}"]`,
      );

      if (!nextPanel) return;

      this.activateTab(tab, currentTab);
      this.changePanel(nextPanel);
    }

    activateTab(nextTab, currentTab) {
      if (currentTab) {
        currentTab.classList.remove("is-active");
        currentTab.setAttribute("aria-selected", "false");
      }

      nextTab.classList.add("is-active");
      nextTab.setAttribute("aria-selected", "true");
    }

    changePanel(nextPanel) {
      window.clearTimeout(this.enterTimer);

      this.querySelectorAll("[data-timeline-panel]").forEach((panel) => {
        if (panel === nextPanel) return;

        panel.classList.remove("is-active", "is-entering", "is-leaving");
        panel.hidden = true;
      });

      nextPanel.hidden = false;
      nextPanel.classList.remove("is-leaving");
      nextPanel.classList.add("is-active", "is-entering");

      this.enterTimer = window.setTimeout(() => {
        nextPanel.classList.remove("is-entering");
      }, 500);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      window.clearTimeout(this.enterTimer);
      this.dataset.ready = "false";
    }
  }

  customElements.define("el-lash-timeline", ElLashTimeline);
}
